import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TSelectForm from "../../common/TSelectForm";

class CommentCaptchaForm extends Component {

    componentDidMount() {
        const { plugin, onChange } = this.props
        if (!plugin.active) {
            onChange({
                setting: {
                    ip: 'all',
                    user: 'all',
                    type: 'bottom'
                },
                validated: true
            })
        }
    }

    @autobind
    handleChangeIp(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                ip: {
                    $set: item.value
                },
            }
        }))
    }

    @autobind
    handleChangeUser(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                user: {
                    $set: item.value
                },
            }
        }))
    }

    @autobind
    handleChangeType(item) {
        const { onChange, data } = this.props
        onChange(update(data, {
            setting: {
                type: {
                    $set: item.value
                },
            }
        }))
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin17">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        그림 문자를
                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'국내/해외 IP 모두', value:'all' },
                            { label:'해외 IP 방문자', value:'visitor' },
                        ]} selected={data.setting.ip} onSelect={this.handleChangeIp}/>,
                        <TSelectForm className="opt_set opt_plugin1" items={[
                            { label:'방문자 모두', value:'all' },
                            { label:'비로그인 방문자', value:'visitor' },
                        ]} selected={data.setting.user} onSelect={this.handleChangeUser}/>
                        에게 적용합니다.
                    </div>
                </div>

                <div className="info_plugin">
                    <div className="item_set item_sub">
                        그림 문자를
                        <TSelectForm className="opt_set opt_plugin2" items={[
                            { label:'바닥형', value:'bottom' },
                            { label:'박스형', value:'box' },
                        ]} selected={data.setting.type} onSelect={this.handleChangeType}/>
                        으로 표시합니다.
                        <span className="txt_other">스킨에 따라 올바르게 보이지 않을 수도 있습니다.</span>
                    </div>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

CommentCaptchaForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default CommentCaptchaForm
